import { userConstants } from "../_constants";

export function users(state = {}, action) {

  switch (action.type) {
    case userConstants.GET_USER_INFO:
      return { ...state, user: action.payload };
    case userConstants.LOGOUT:
      return { ...state, user: null};
    default:
     
      return state;
  }
}
